import logo1 from '../../../../assets/HomePage/logo1.png';
import logo2 from '../../../../assets/HomePage/logo2.png';
import logo3 from '../../../../assets/HomePage/logo3.png';
import logo4 from '../../../../assets/HomePage/logo4.png';
import logo5 from '../../../../assets/HomePage/logo5.png';
import logo6 from '../../../../assets/HomePage/logo6.png';
import logo7 from '../../../../assets/HomePage/logo7.png';
import logo8 from '../../../../assets/HomePage/logo8.png';
import logo9 from '../../../../assets/HomePage/logo9.png';
import logo10 from '../../../../assets/HomePage/logo10.png';
import logo11 from '../../../../assets/HomePage/logo11.png';
import logo12 from '../../../../assets/HomePage/logo12.png';
import { Grid, Typography, Paper } from '@mui/material';

let logos = [logo1, logo2, logo3, logo4, logo5, logo6, logo7, logo8, logo9, logo10, logo11, logo12];

const OurMembers = (props) => {
  return (
    <Paper
      elevation={20}
      sx={{
        padding: { xs: '2rem', md: '4rem' },
        mt: '6rem',
        borderRadius: 5,
        textAlign: 'center',
      }}>
      <Typography
        variant='h4'
        component='h2'
        sx={{
          fontWeight: 'bold',
          maxWidth: { xs: '100%', sm: '70%' },
          mx: 'auto',
        }}>
        A private network for 100 of the most successful SaaS Founders.
      </Typography>
      <Typography variant='body1' sx={{ mt: '1.2rem' }}>
        Connect with a powerful suite of SaaS Founders from diverse backgrounds, industries, and organizations. Our
        members consist of founders who are giants in their respective fields.
      </Typography>
      <Grid columnSpacing={{ xs: 4, md: 3, lg: 2 }} rowSpacing={3} container sx={{ mt: '1rem', alignItems: 'center' }}>
        {Array.from(Array(12)).map((_, index) => (
          <Grid item xs={6} md={3} lg={2} key={index}>
            <img src={logos[index]} alt={`logo${index + 1}`} style={{ maxHeight: '70px', maxWidth: '100%' }}></img>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};

export default OurMembers;
